import { Mail, Instagram, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { ADDRESS, EMAIL, IG_URL, BOOK_URL, M } from "../lib/site";
import { MaskLines, FadeUp } from "./Reveal";

const Row = ({ icon: Icon, label, children, href, testid }) => {
  const inner = (
    <>
      <Icon size={20} className="mt-1 shrink-0 text-[var(--glow)]" />
      <div className="min-w-0">
        <p className="field-label mb-1">{label}</p>
        <p className="break-words text-xl font-light tracking-wide text-[#F8F6F0] transition-colors duration-300 group-hover:text-[var(--glow)] sm:text-3xl">{children}</p>
      </div>
    </>
  );
  const cls = "group flex gap-5 border-b border-[var(--line)] py-7";
  return href
    ? <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className={cls} data-testid={testid}>{inner}</a>
    : <div className={cls} data-testid={testid}>{inner}</div>;
};

export const Contact = () => (
  <section id="contact" className="relative mx-auto max-w-[1400px] px-5 py-24 sm:px-10 sm:py-36" data-testid="contact-section">
    <p className="eyebrow mb-6">06 — Contact</p>
    <MaskLines lines={["Find", "Us."]}
      className="font-display text-6xl leading-[0.9] text-[#F8F6F0] sm:text-6xl lg:text-8xl" />
    <div className="mt-16 grid gap-12 lg:grid-cols-2 lg:gap-20">
      <FadeUp>
        <Row icon={Mail} label="Email" href={`mailto:${EMAIL}`} testid="contact-email-link">{EMAIL}</Row>
        <Row icon={Instagram} label="Instagram" href={IG_URL} testid="contact-ig-link">@elegantemelbourne</Row>
        <Row icon={MapPin} label="Address" href={`https://maps.google.com/?q=${encodeURIComponent("412 Little Collins St, Melbourne VIC 3000")}`} testid="contact-address-link">
          Level 1 / 412 Little Collins St, Melbourne VIC 3000
        </Row>
        <Row icon={Clock} label="Hours" testid="contact-hours">Every Friday · 9PM til late</Row>
        <a href={BOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-book-btn"
          className="btn-gold mt-10 inline-flex items-center gap-3 rounded-full px-9 py-5 text-[13px] font-semibold uppercase tracking-[0.2em]">
          Book Bottomless <ArrowUpRight size={16} />
        </a>
      </FadeUp>
      <FadeUp delay={0.15}>
        <div className="relative h-[380px] overflow-hidden rounded-[28px] border border-[var(--line)] sm:h-full sm:min-h-[520px]" data-testid="contact-map">
          <iframe title="Eleganté location map" className="map-dark h-full w-full" loading="lazy"
            src={`https://maps.google.com/maps?q=${encodeURIComponent(ADDRESS)}&z=16&output=embed`} />
          <div className="pointer-events-none absolute bottom-4 left-4 flex items-center gap-3 rounded-full border border-[var(--line)] bg-[#09080B]/85 px-4 py-2.5 backdrop-blur-md">
            <img src={M.logo} alt="" className="h-5" />
            <span className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#F8F6F0]">Level 1</span>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);
